import React, { useContext, Fragment } from 'react';
import { withStyles, Divider, Grid } from '@material-ui/core';
import DataContext from '../../data/DataContext';
import LeftTail from '../../../asset/img/bubble_point1.png';
import NoticeIcon from '../../../asset/img/ico_cb_notice.svg';

const styles = (theme) => ({
  root: {
    display: 'flex',
    letterSpacing: '-0.5px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  message: {
    fontSize: theme.font.size15, // "15px",
    borderRadius: '12px',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    maxWidth: '75%',
    zIndex: 10,
    wordWrap: 'break-word',
  },
  cbMessage: {
    width: '100%',
    // fontSize: theme.font.size15, // "15px",
    // borderRadius: "12px",
    // flexWrap: "wrap",
    // color: theme.color.message.color,
    // zIndex: 10,
    // wordWrap: "break-word",
  },
  leftMessage: {
    backgroundColor: theme.color.message.background,
    margin: '6px 6px 6px 9px',
    boxShadow: '0px 12px 12px rgba(194, 194, 194, 0.58)',
    fontWeight: '300',
  },
  rightMessage: {
    backgroundColor: theme.color.message.background,
    margin: '8px 10px',
    boxShadow: 'none',
  },

  list: {
    display: 'flex',
    width: '100%',
    borderRadius: '0px 0px 12px 12px',
    border: '0px',
    alignItems: 'center',
    background: '#fafafa',
  },
  item: {
    height: '40px',
    textAlign: 'center',
    color: theme.color.accent,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0px',
    margin: '0px',
    flex: 1,
    backgroundColor: '#FAFAFA',
    textTransform: 'none',
    // outline: "0 none",
    border: '0px',
    borderRadius: '0px 0px 12px 12px',
    // "&:active": {
    //   backgroundColor: "rgba(38, 38, 38, 0.1)",
    // },
  },
  itemLeft: {
    borderRadius: '0px 0px 0px 12px',
  },
  itemRight: {
    borderRadius: '0px 0px 12px 0px',
  },
  itemDisabled: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  vertical: {
    height: '20px',
    backgroundColor: theme.color.list_divider,
  },
  leftTail: {
    // borderLeft: '14px solid transparent',
    // borderRight: '14px solid transparent',
    // borderTop: '18px solid #fff',
    // borderRadius: '5px',
    zIndex: 11,
    margin: '6px -21px 0px 11px',
    backgroundImage: `url(${LeftTail})`,
    backgroundSize: '21px 12px',
    width: '21px',
    height: '12px',
    minWidth: '21px',
  },
  ti: {
    width: '100%',
    padding: '12px 20px',
    margin: '0px',
  },
  title: {
    fontSize: theme.font.size15, // "15px",
    fontWeight: 'bold',
    color: theme.color.text,
  },
  tiList: {
    marginTop: '12px',
    color: theme.color.text,
  },
  listRow: {
    display: 'flex',
    alignItems: 'center',
  },
  key: {
    minWidth: '3.75rem',
    height: '2rem',
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    height: '2rem',
    fontSize: theme.font.size15, // "15px",
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
  },
  textBox: {
    width: 'auto',
    minHeight: '2.75rem',
    borderRadius: '10px',
    backgroundColor: theme.color.message.background,
    margin: '3px 16px',
    display: 'flex',
    color: theme.color.message.color,
    // alignItems: "center",
    justifyContent: 'flex-start',
    padding: '16px',
    fontSize: theme.font.size14,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  titleBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 0 12px 0',
  },
  titleIcon: {
    minWidth: '1.5rem',
    minHeight: '1.5rem',
  },
  titleStr: {
    color: theme.color.message.color,
    fontSize: theme.font.size15,
    padding: '0 0 0 6px',
    fontWeight: 'bold',
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 16px',
  },
  button0: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '6px',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
    color: '#fff',
    margin: '3px 0',
  },
  button1: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '6px',
    border: 'solid 1px #ea1917', //"solid 1px #da0f47",
    backgroundColor: '#fff',
    fontWeight: 'bold',
    color: '#ea1917', //"#da0f47",
    margin: '3px 0',
  },
  buttonMore: {
    width: '100%',
    minHeight: '2.875rem', // 46px
    borderRadius: '6px',
    border: '0px',
    fontWeight: 'bold',
    backgroundColor: '#f6f6f6',
    color: theme.color.message.color,
    margin: '3px 0',
  },
  scrollArea: {
    width: '100%',
    padding: '10px 16px',
  },
  scrollBox: {
    width: '100%',
    padding: '10px',
    backgroundColor: '#fff',
    overflowY: 'auto',
    maxHeight: '200px',
    display: 'flex',
    color: theme.color.message.color,
    // alignItems: "center",
    justifyContent: 'flex-start',
    fontSize: theme.font.size14,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },

  scrollBody: {
    padding: '10px 0px',
  },
});

function CBScroll(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  const handleClick = (button) => {
    context.request(context, button.speech, 'button');
  };

  return data.subType && data.subType.toUpperCase() === 'TI' ? (
    <>
      <div
        className={[
          classes.root,
          data.mine ? classes.rightContainer : classes.leftContainer,
        ].join(' ')}
      >
        {!data.mine && <div className={classes.leftTail} />}
        <div
          className={[
            classes.message,
            data.mine ? classes.rightMessage : classes.leftMessage,
          ].join(' ')}
        >
          {data.text && (
            <div>
              {data.text.split('\n').map((content, index) => (
                <Fragment key={index}>
                  {content}
                  <br />
                </Fragment>
              ))}
            </div>
          )}

          <div className={classes.ti}>
            <div className={classes.title}>{data.title}</div>
            <div className={classes.tiList}>
              {data.listItems.map((item) => (
                <Grid container className={classes.listRow} role={'text'}>
                  <Grid item className={classes.key}>
                    {item.key}
                  </Grid>
                  <Grid item className={classes.value}>
                    {item.value}
                  </Grid>
                </Grid>
              ))}
            </div>
          </div>

          <Divider component={'div'} disabled />
          {!data.loading && (
            <div className={classes.list}>
              {data.buttons.map((button, index) => (
                <>
                  <Divider
                    className={classes.vertical}
                    orientation={'vertical'}
                    hidden={index === 0}
                    component={'div'}
                    disabled
                  />
                  <button
                    type="button"
                    className={[
                      classes.item,
                      index === 0 && data.buttons.length > 1 ? classes.itemLeft : '',
                      index === data.buttons.length - 1 && data.buttons.length > 1
                        ? classes.itemRight
                        : '',
                      !data.isLast || context.conversationEnd ? classes.itemDisabled : '',
                    ].join(' ')}
                    disabled={!data.isLast || context.conversationEnd}
                    onClick={() => handleClick(button)}
                  >
                    {button.label}
                  </button>
                </>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={classes.root}>
        <div className={classes.cbMessage}>
          {data.text && (
            <div className={classes.textBox}>
              {data.title && (
                <div className={classes.titleBox}>
                  <img
                    className={classes.titleIcon}
                    src={NoticeIcon}
                    alt={context.string.aria.icon.imgNotice}
                  />
                  <div className={classes.titleStr}>{data.title}</div>
                </div>
              )}
              {data.text.split('\n').map((content, index) => (
                <Fragment key={index}>
                  {content}
                  <br />
                </Fragment>
              ))}
            </div>
          )}

          {data.scrollTitle && (
            <div className={classes.scrollArea}>
              <div className={classes.scrollBox}>
                {data.scrollTitle}
                {data.scrollBody && (
                  <div className={classes.scrollBody}>{data.scrollBody}</div>
                )}
              </div>
            </div>
          )}

          <div className={classes.buttonBox}>
            {data.buttons.map((buttonData, butIndex) => {
              return (
                <button
                  type="button"
                  className={[
                    butIndex === 0
                      ? classes.button0
                      : butIndex === 1
                      ? classes.button1
                      : classes.buttonMore,
                    data.isLast || context.conversationEnd ? classes.itemDisabled : '',
                  ].join(' ')}
                  disabled={!data.isLast || context.conversationEnd}
                  onClick={() => handleClick(buttonData)}
                >
                  {buttonData.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
export default withStyles(styles)(CBScroll);
